export const SIDEBAR_STORAGE_KEY = 'ai_platform_sidebar';
export const LANGUAGE_STORAGE_KEY = 'ai_platform_language';
export const TOKEN_STORAGE_KEY = 'ai_platform_token';
export const USER_STORAGE_KEY = 'ai_platform_user';
export const ADVANCED_MODE_STORAGE_KEY = 'ai_platform_advanced_mode';
